import { render, staticRenderFns } from "./OrgSettingsAdmins.vue?vue&type=template&id=755895ae&scoped=true&"
import script from "./OrgSettingsAdmins.vue?vue&type=script&lang=js&"
export * from "./OrgSettingsAdmins.vue?vue&type=script&lang=js&"
import style0 from "./OrgSettingsAdmins.vue?vue&type=style&index=0&id=755895ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755895ae",
  null
  
)

export default component.exports